import { MutationTree } from 'vuex'
import { SignInState } from './types'

export enum SignInMutations {
  SET_LOADER = 'SET_LOADER',
  SET_USERNAME = 'SET_USERNAME',
  SET_LOADED_CONTENT = 'SET_LOADED_CONTENT',
  SET_DEVICEID = 'SET_DEVICEID'
}

export const mutations: MutationTree<SignInState> = {
  [SignInMutations.SET_LOADER](state, payload: boolean) {
    state.loading = payload
  },

  [SignInMutations.SET_USERNAME](state, payload: string) {
    state.username = payload
  },

  [SignInMutations.SET_LOADED_CONTENT](state, payload: Object) {
    state.content = payload
  },

  [SignInMutations.SET_DEVICEID](state, payload: number) {
    state.deviceId = payload
  }
}
